exports['undefined'] = undefined;



//////////////////
// WEBPACK FOOTER
// ./output/Data.Foreign.NullOrUndefined/foreign.js
// module id = 581
// module chunks = 0